module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-header', [_c('small', [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" X "), _c('small', [_vm._v(_vm._s(_vm.against.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('character', {
    ref: "player",
    attrs: {
      "current-health": _vm.currentHealth.player,
      "player": _vm.player
    },
    on: {
      "attack": _vm.attack
    }
  }), _vm._v(" "), _c('actions', {
    attrs: {
      "items": _vm.actions.player
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('character', {
    ref: "against",
    attrs: {
      "is-cpu": true,
      "current-health": _vm.currentHealth.against,
      "player": _vm.against
    }
  }), _vm._v(" "), _c('actions', {
    attrs: {
      "items": _vm.actions.against
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7441f4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/battle/index.vue
// module id = 124
// module chunks = 1